import type { AppProduct } from "@shared/interfaces/product";
import { createLogger } from "../logger.ts";

const logger = createLogger("FetchProducts");

const BACKEND_BASE_URL: string = import.meta.env.VITE_BACKEND_BASE_URL!;

const normalizeProductResponse = (data: unknown): AppProduct[] => {
    return Array.isArray(data) ? (data as AppProduct[]) : [];
};

export const fetchProductsByGoal = async (goal: string): Promise<AppProduct[]> => {
    return fetch(`${BACKEND_BASE_URL}/api/product/get?goal=${goal}`)
        .then((response) => response.json())
        .then((data) => {
            logger.debug("Fetched products", { data });

            return normalizeProductResponse(data);
        });
};

export const fetchProductsByType = async (type: string): Promise<AppProduct[]> => {
    return fetch(`${BACKEND_BASE_URL}/api/product/get?type=${encodeURIComponent(type)}`)
        .then((response) => response.json())
        .then((data) => {
            logger.debug("Fetched products", { data });

            return normalizeProductResponse(data);
        });
};